import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyledTagCategory, StyledTagText } from './style';

/** Actions */
import { setQueryString } from '../../../actions/header';

const TagCategory = ({ type, className, category, onSetQueryString }) => (
  <StyledTagCategory
    onClick={() => onSetQueryString(category)}
    type={type}
    className={`${className} TagCategory`}
  >
    <StyledTagText>{category}</StyledTagText>
  </StyledTagCategory>
);

TagCategory.propTypes = {
  className: PropTypes.string,
  category: PropTypes.string.isRequired,
  type: PropTypes.string
};

TagCategory.defaultProps = {
  type: 'primary'
};

const mapDispatchToProps = dispatch => ({
  onSetQueryString: category => setQueryString(category, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(TagCategory);
